import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography';
import ExpansionPanel, { ExpansionPanelSummary, ExpansionPanelDetails } from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

const ControlSite = (props) => (
	<ExpansionPanel defaultExpanded={true}>
		<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
			<Typography className={props.classes.heading}>Site</Typography>
		</ExpansionPanelSummary>
		<ExpansionPanelDetails>
			<Grid container>
				<Grid item xs={12} sm={6} md={4}>
					<TextField name="name" label="Name" value={props.name} fullWidth onChange={props.change} helperText="The name of the site" />
				</Grid>
				<Grid item xs={12} sm={6} md={4}>
					<TextField name="packageKey" label="Package-Key" value={props.packageKey} fullWidth onChange={props.change} helperText="The name of the site package" />
				</Grid>
				<Grid item xs={12} sm={6} md={4}>
					<TextField name="nodeName" label="Node-Name" value={props.nodeName} fullWidth onChange={props.change} helperText="The path in /sites" />
				</Grid>
			</Grid>
		</ExpansionPanelDetails>
	</ExpansionPanel>
);

ControlSite.propTypes = {
	classes: PropTypes.object.isRequired,
	name: PropTypes.string.isRequired,
	packageKey: PropTypes.string.isRequired,
	nodeName: PropTypes.string.isRequired,
	change: PropTypes.func.isRequired
};

const styles = theme => ({
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightRegular
	}
});

export default withStyles(styles)(ControlSite);



// WEBPACK FOOTER //
// ./src/components/SiteGenerator/ControlSite.js